<div class="action-container">
  <div class="alert-action-wrapper">
    <app-ag-action-icon-button
      [iconClass]="alertIconClass"
      [numberOfAlerts]="numberOfNewAlerts"
      [disabled]="!numberOfAlerts"
      (action)="numberOfAlerts && onOpenAlerts()"
    />
  </div>

  <app-ag-action-icon-button
    iconClass="ic-notes-16"
    (action)="onOpenNotes()"
  />

  <a [routerLink]="companyProfilePageLink">
    <app-ag-action-icon-button iconClass="ic-eye-16"/>
  </a>

  <div
    *appHasRole="['Admin', 'Manager', 'Preparer']"
    ngbDropdown
    container="body"
    class="dropdown d-inline-flex"
    [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']"
  >

    <app-ag-action-icon-button ngbDropdownToggle iconClass="ic-more-horizontal-16"/>

    <div ngbDropdownMenu class="common-dropdown-menu dropdown-menu dropdown-menu-right">
      <button ngbDropdownItem class="dropdown-item" (click)="editPartnerAndAccountManager()">
        <span>Edit Partner and Account Manager</span>
      </button>

      <button ngbDropdownItem class="dropdown-item" (click)="downloadCompanyProfilePdf()">
        <span>Download Company Profile</span>
      </button>
    </div>
  </div>
</div>
